import React from 'react';

import { observer } from 'mobx-react';

import styles from './color-indicator.module.scss';

interface ColorIndicatorProps {
	color: string;
	dataTestId: string;
}
const ColorIndicator = ({ color, dataTestId }: ColorIndicatorProps) => {
	return <div className={styles.colorIndicator} style={{ backgroundColor: color }} data-test-id={dataTestId}></div>;
};

export default observer(ColorIndicator);
